import { oofDtos } from '@vectronic/openApi-customer';

/** Identity of a device: the id is only unique within its own device class. */
export type DeviceKey = string;

export function deviceKeyOf(device: { deviceClass?: string; id?: number }): DeviceKey {
  return `${device.deviceClass}:${device.id}`;
}

/** An order item's devices as the backend holds them after an allocation was saved. */
export type SavedDeviceAllocations = {
  orderId: oofDtos.OofOrder['id'];
  allocationsByOrderItemId: Record<number, oofDtos.DeviceAllocation[]>;
};

/** Devices the configuration no longer covers go back to the pool; `undefined` leaves the distribution alone. */
export function withDevicesDistributedTo(
  allocations: oofDtos.DeviceAllocation[],
  configurationId: string,
  devices: oofDtos.ConfigurationDevice[] | undefined,
): oofDtos.DeviceAllocation[] {
  if (!devices) return allocations;

  const covered = new Set(devices.map(deviceKeyOf));
  return allocations.map((allocation) => {
    if (covered.has(deviceKeyOf(allocation))) return { ...allocation, configurationId };
    return allocation.configurationId === configurationId
      ? { ...allocation, configurationId: undefined }
      : allocation;
  });
}

export function withDevicesReturnedToPool(
  allocations: oofDtos.DeviceAllocation[],
  configurationId: string,
): oofDtos.DeviceAllocation[] {
  return withDevicesDistributedTo(allocations, configurationId, []);
}
